<template>
    <div class="ut-flex ut-fc">
    
        <button
          v-for="item in buttonList"
          :key="item.value"
          class="dt-button dt-button v5 s8"
        
          @click="onClick(item.value)"
          style="margin-top: 8px; margin-left: 0px;width:120px;min-width:155px"
        >
           {{item.text}}
        </button>
    </div>
</template>
<script>
  // :disabled="disabledButton(item)"
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { distributionAccountListLDTRoutes } from '../../router/routes';
import { invoiceListLDTRoutes } from '../../../accounting/router/routes';
import { distributionStatementsActions } from '../../store/statement/actions';
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";
import { DistributionStatementService } from '../../services/statement.service';
export default {
  props: {
    selectedStatementDetails: {
      type: Object
    },
    buttonList:{
      type:Array
    }
  },
  components: {

    DBox
  },
  data: function() {
    return {
    };
  },
  computed: {

    all_lines_assigned:function(){
      return this.selectedStatementDetails?.all_lines_assigned
    },

    currentChannel:function(){
      return this.selectedStatementDetails?.statement?.digital_physical||'';
    },
    invoice_id:function(){
      return this.selectedStatementDetails?.statement?.invoice_id||''
    },

    rightMenu:function(){
      if(this.invoice_id==''){
        return [
          {
            text: this.$t('invoice_statement'),
            value: 'invoice_statement',
          },
          {
            text: this.$t('refresh'),
            value: 'refresh',
          },
          {
            text: this.$t('ppu_fix_amount_btn'),
            value: 'ppu_fix_amount_btn',
          },
        ]
      }else{
        return [
          {
            text: this.$t('open_related_invoice'),
            value:'open_related_invoice'
          }
        ]
      }
    }


  },
  methods: {
     ...mapActionObject(storeNS, distributionStatementsActions),
     onClick:function(menu){
        this.$emit('menuClick',menu)
     },
     disabledButton:function(item){
      if(item.value == 'invoice_statement' && this.all_lines_assigned==0){
          return true;
      }
      return false;
     },

  }
};
</script>
